// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"W1-z"};